<template>
  <div>
    <!-- <v-overlay :value="loadingReport">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->

    <div v-if="false">
      <v-row no-gutters justify="center">
        <v-col xs="12" sm="12" md="6" lg="6" xl="6">
          <v-autocomplete
            v-model="reportSelectValueSelected"
            :items="reportSelectItems"
            label="Select Report"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>

    <div v-if="reportErrorMessage">
      <v-row>
        <v-col cols="12">
          <v-alert
            type="error"
          >Server error: Please refresh page, try again, and if fails again contact support@beringar.co.uk with a fault
            description if
            error persists
            <br> Error detail: {{ reportErrorMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </div>

    <div v-if="!selectedBuildingInfo">
      <v-alert type="info">
        Loading building info .... please wait
      </v-alert>
    </div>

    <div v-if="selectedBuildingInfo">
      <div v-if="loadingReport">
        <v-alert type="info">
          Creating download .... please wait
        </v-alert>
      </div>

      <v-row>
        <v-col col="12">
          <v-card flat>
            <v-card-text>
              <v-row>

                <v-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <v-autocomplete outlined dense
                                  :items="reportTypeDropdownItems"
                                  v-model="reportTypeValueSelected"
                                  label="REPORT TYPE"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <v-autocomplete outlined dense
                                  :items="reportGroupDropdownItems"
                                  v-model="reportGroupValueSelected"
                                  label="GROUPED BY"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <v-autocomplete outlined dense
                                  :items="reportAggregationDropdownItems"
                                  v-model="reportAggregationValueSelected"
                                  label="AGGREGATED BY"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="3" xl="3">
                  <v-autocomplete outlined dense
                                  :items="reportPeriodDropdownItems"
                                  v-model="reportPeriodValueSelected"
                                  v-on:change="periodSelectControlChange"
                                  label="OVER PERIOD"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12" sm="6" md="6" lg="3" xl="3">
                  <v-switch v-model="customiseGraph.swapGroups" label="Swap Groups In Graphs"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="3" xl="3">
                  <v-switch v-model="customiseGraph.lineGraph" label="Line Graph"></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" xl="2">
                  <div v-if="showSpaceFilter">
                    <v-btn block
                           class="layer-btn"
                           :disabled="!nextReportIsInCache"
                           :style="{
                      backgroundColor : displaySpaceFilters ? 'black !important' : '',
                      color: displaySpaceFilters ? 'white !important' : 'black'}"
                           outlined
                           @click="displaySpaceFilters = !displaySpaceFilters"
                    >{{ spaceFilterButtonText }}
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" xl="2">
                  <v-btn block
                         :style="{
                      backgroundColor : displayManagedSpaceFilters ? 'black !important' : '',
                      color: displayManagedSpaceFilters ? 'white !important' : 'black'}"
                         class="layer-btn"
                         outlined
                         @click="clickDisplayManagedSpaceFilters"
                  >{{ managedSpaceFilterButtonText }}
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" xl="2">
                  <v-btn block
                         :style="{
                      backgroundColor : displayTimeFilters ? 'black !important' : '',
                      color: displayTimeFilters ? 'white !important' : 'black'}"
                         class="layer-btn"
                         outlined
                         @click="clickDisplayTimeFilters"
                  >{{ timeFilterButtonText }}
                  </v-btn>
                </v-col>
              </v-row>

              <div v-if="false">
                <v-row no-gutters pa-0>
                  <v-col cols=12>
                    <div style="text-align:center">
                      {{ timeFilterSummary }} <br>
                      {{ spaceFilterSummary }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Use v-show here to prevent list from losing selection -->
      <div v-show="displayManagedSpaceFilters">
        <ManagedSpaceSelectFromBuilding
          :managedSpaces="selectedBuildingManagedSpaces"
          v-model="selectedManagedSpaces"></ManagedSpaceSelectFromBuilding>
      </div>

      <div v-if="displayTimeFilters">
        <v-row>
          <v-col col="12">
            <InsightReportTimeFilters v-model="timeFilters"></InsightReportTimeFilters>
          </v-col>
        </v-row>
      </div>

      <div v-if="displaySpaceFilters">
        <v-row>
          <v-col col="12">
            <InsightReportSpaceFilters v-model="spaceFilters"></InsightReportSpaceFilters>
          </v-col>
        </v-row>
      </div>

      <div v-show="showDebug || (nextReportIsInCache && !loadingReport && !reportErrorMessage)">
        <v-card outlined>
          <div v-show="chartClusterType === 'single'">
            <v-row>
              <v-col cols="12">
                <InsightHighchartWithTwoDimensionGrouping :group1="chartGroup1"
                                                          :group2="chartGroup2"
                                                          :plotted="chartColumnPlotted"
                                                          :percentformat="chartPlottedPercent"
                                                          :percentscale="false"
                                                          :axislabel="chartAxisLabel"
                                                          :titlepart1="chartTitlePart1"
                                                          :subtitle="timeFilterSummary + '<br>' + spaceFilterSummary"
                                                          :graphtype="graphType"
                                                          :debug="showDebug"
                                                          :swapgroups="customiseGraph.swapGroups"
                                                          :values="selectedBuildingReportFilteredDataTableValues"></InsightHighchartWithTwoDimensionGrouping>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </div>
          <div v-if="chartClusterType === 'timeofday'">
            <v-row>
              <v-col cols="12">
                <v-alert type="error">TODO - time of day chart</v-alert>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>

      <div v-if="false">
        <div v-if="(nextReportIsInCache && !loadingReport && !reportErrorMessage)">
          <v-row>
            <v-col col="12">
              <InsightReportManagedSpaceTable
                title="Detailed Space Use Data"
                :rows="selectedBuildingReportFilteredDataTableValues"
              ></InsightReportManagedSpaceTable>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="showDebug || (nextReportIsInCache && showRawReportData && !loadingReport && !reportErrorMessage)">
        <v-row>
          <v-col col="12">
            <InsightReportRawTable
              title="Raw Report Data"
              :rows="selectedBuildingReportRawDataTableValues"
            ></InsightReportRawTable>
          </v-col>
        </v-row>
      </div>

      <v-row v-if="showDebug">
        <v-col col="12">
          <InsightReportRawTable
            title="Insights Report Filtered Table (Beringar Debug Only)"
            :rows="selectedBuildingReportFilteredDataTableValues"
          ></InsightReportRawTable>
        </v-col>
      </v-row>

      <div v-if="showDebug">
        <v-row>
          <v-col col="12">
            <v-card>
              <p>Result url: {{ resultUrl }}</p>
              <p>Start and end dates: {{ startDate }} - {{ endDate }} ({{ numberDays }} days)</p>
              <p>Loading: {{ loadingReport }}</p>
              <p>Next Report Is In Cache: {{ nextReportIsInCache }}</p>
              <p>cachedReport.status {{ cachedReport ? cachedReport.status : '-' }}</p>
              <p>cachedReport.status {{ cachedReport ? cachedReport.error : '-' }} </p>
              <p>Report error message: {{ reportErrorMessage }}</p>
              <p></p>
              <p>Report Select Value Selected: {{ reportSelectValueSelected }}</p>
              <p>Report period value selected: {{ reportPeriodValueSelected }}</p>
              <p>Display Group 2: {{ chartGroup2 }}</p>
              <p>Next request payload: {{ nextRequestPayload }}</p>
              <p>Next report in cache: {{ nextReportIsInCache }}</p>
              <p>Report type: {{ reportTypeValueSelected }}</p>
              <p>Report Aggregation Value Selected: {{ reportAggregationValueSelected }}</p>
              <p>Time filters: {{ debugTimeValues }}</p>
              <p>Space filters: {{ debugSpaceValues }}</p>
              <p>Managed space filters: {{ selectedManagedSpaces }}</p>
              <p>Chart cluster type: {{ chartClusterType }}</p>
              <p>Graph Type {{ graphType }}</p>
              <!-- <p>Filtered values {{ selectedBuildingReportFilteredDataTableValues }}</p>-->
              <p>Cached Report: {{ cachedReport }}</p>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-show="!nextReportIsInCache && !loadingReport">
        <div v-if="dateRangeTooLong">
          <v-layout justify-center>
            <v-alert type="warning">Warning<br>Selected date period of {{ numberDays }} days is too long.<br>
              Maximum aggregation period for '{{ reportAggregationValueSelected.textLong }}' is
              {{ reportAggregationValueSelected.maxDays }} days.
              <!-- <br>To download longer period select 'Long Period' in aggregation option. -->
            </v-alert>
          </v-layout>
        </div>
        <div v-if="!dateRangeTooLong">
          <div v-if="showExtendedPeriodWarning">
            <v-layout justify-center>
              <v-alert type="info">Note: <br>Extended Aggrgation Period Selected<br>Graphs Many Not Render Correctly &
                No Managed Space Data In Raw Data <br>Intended To Enable Raw Data Download Only
              </v-alert>
            </v-layout>
          </div>
          <v-layout justify-center>
            <v-btn
              class="layer-btn-large"
              large tile
              color="primary"
              @click="clickLoadReportData"
            >LOAD REPORT DATA
            </v-btn>
          </v-layout>
          <br/>
          <v-layout justify-center>
            Search Date Period From {{ startDate }} To {{ endDate }}
          </v-layout>
          <v-layout justify-center>
            This analyses up to 1 billion records and can take around 10 seconds.
          </v-layout>
        </div>
      </div>

      <div v-show="loadingReport">
        <v-layout justify-center>
          <v-alert type="info">
            Fetching report data ... typical wait time is 10 to 30 seconds
          </v-alert>
        </v-layout>
      </div>

      <div v-show="nextReportIsInCache && !reportErrorMessage">
        <div v-if="resultUrl">
          <v-layout justify-center>
            <strong>
              <a :href="resultUrl" target="_blank">Click to download raw data (valid 30 min)</a>
              <p></p>
            </strong>
          </v-layout>
        </div>
        <div v-if="false">
          <v-row justify="center">
            <v-col cols="12" sm="6" md="6" lg="3" xl="3" align="center">
              <v-btn
                class="layer-btn"
                :style="{
                      backgroundColor : showRawReportData  ? 'black !important' : '',
                      color: showRawReportData  ? 'white !important' : 'black'}"
                large
                outlined tile
                @click="showRawReportData = !showRawReportData"
              >{{ reportDataButtonText }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <div v-if="isStaff && showDebugButtonForStaff">
      <v-layout justify-center>
        <v-btn
          class="layer-btn"
          large tile
          outlined
          :style="{
                      backgroundColor : showDebug ? 'black !important' : '',
                      color: showDebug ? 'white !important' : 'black'}"
          @click="showDebug = !showDebug"
        >{{ showDebug ? 'HIDE DEBUG' : 'SHOW DEBUG (STAFF ONLY)' }}
        </v-btn>
      </v-layout>
      <p></p>
      <p></p>
    </div>

    <!--<div v-if="nextReportIsInCache && !loadingReport">-->
    <div v-if="(isStaff && nextReportIsInCache) || showDebug">
      <v-row>
        <v-col col="12">
          <InsightReportStatusPanel :cached="cachedReport"></InsightReportStatusPanel>
        </v-col>
      </v-row>
      <p></p>
      <p></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InsightReportTimeFilters from './InsightReportTimeFilters'
import InsightReportSpaceFilters from './InsightReportSpaceFilters'
import InsightReportManagedSpaceTable from './InsightReportManagedSpaceTable'
import InsightReportRawTable from './InsightReportRawTable'
import InsightHighchartWithTwoDimensionGrouping from './highchart/InsightHighchartWithTwoDimensionGrouping'
import InsightReportStatusPanel from './InsightReportStatusPanel'
import ManagedSpaceSelectFromBuilding from './ManagedSpaceSelectFromBuilding'
import dateUtil from '../lib/dateUtil'
import reportutil from '../lib/reportUtil'
import _ from 'lodash'
import reportSelects from '../lib/reportSelects'
import reportSummarySelects from '../lib/reportSummarySelects'
import moment from 'moment'

function secToStringPretty (val) {
  let hours = Math.floor(val / 3600)
  let totalSeconds = val % 3600
  let minutes = Math.floor(totalSeconds / 60)
  // let seconds = totalSeconds % 60;
  return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
}

function dowArrayToStringPretty (val) {
  if (val.length === 7) {
    return 'any day of week'
  }
  if (val.length === 0) {
    return 'any day of week'
  }
  if ((val.length === 5) && (!val.includes(6)) && (!val.includes(7))) {
    return 'all working days of week'
  }
  let dowCopy = val.slice()
  dowCopy.sort()
  let dayArray = dowCopy.map(x => dateUtil.daysOfWeekDict[x].short)
  return dayArray.join()
}

function extractDistinctValuesFromArrayColumn (data, column) {
  let columnOfInterest = data.map(row => row[column])
  let distinct = _.uniq(columnOfInterest)
  if (distinct.length === 1) { // Treat null type alone as no options to select
    if (!distinct[0]) {
      distinct = []
    }
  }
  return distinct.sort()
}

function updateSpaces (val) {
  console.log('Start - Raw data tables changed - update spaces')
  this.spaceFilters.groupSpaceType = extractDistinctValuesFromArrayColumn(val, 'space_type')
  console.log('groupSpaceType found', this.spaceFilters.groupSpaceType)
  this.spaceFilters.groupSpaceTypeValue = _.clone(this.spaceFilters.groupSpaceType)

  this.spaceFilters.groupSpaceAccess = extractDistinctValuesFromArrayColumn(val, 'space_position')
  console.log('groupSpaceAccess found', this.spaceFilters.groupSpaceAccess)
  this.spaceFilters.groupSpaceAccessValue = _.clone(this.spaceFilters.groupSpaceAccess)

  this.spaceFilters.groupSpaceGroup = extractDistinctValuesFromArrayColumn(val, 'space_department')
  console.log('groupSpaceGroup found', this.spaceFilters.groupSpaceGroup)
  this.spaceFilters.groupSpaceGroupValue = _.clone(this.spaceFilters.groupSpaceGroup)

  this.spaceFilters.groupFloorNumber = extractDistinctValuesFromArrayColumn(val, 'floor_number')
  console.log('groupFloorNumber found', this.spaceFilters.groupFloorNumber)
  this.spaceFilters.groupFloorNumberValue = _.clone(this.spaceFilters.groupFloorNumber)
  console.log('End - Raw data tables changed - update spaces')
}

function generateTimeFilterSummaryText () {
  let result = 'Report from ' + this.startDate + ' to ' + this.endDate + '<br>'
  if (this.timeFilters.filterByTimeOfDay) {
    result += 'Between ' + secToStringPretty(this.timeFilters.timeOfDayFilterStartSec) + ' and ' +
      secToStringPretty(this.timeFilters.timeOfDayFilterEndSec)
  } else {
    result += 'At any time of day '
  }
  result += ' on ' + dowArrayToStringPretty(this.timeFilters.daysOfWeekFilterValue)
  result += ' in ' + this.timeFilters.currentTimezone
  return result
}

function generateSpaceFilterSummaryText () {
  let result = this.spaceFilters.groupSpaceGroupValue.length + ' of ' + this.spaceFilters.groupSpaceGroup.length + ' Space Department selected. '
  result += this.spaceFilters.groupSpaceTypeValue.length + ' of ' + this.spaceFilters.groupSpaceType.length + ' Space Type selected. '
  result += this.spaceFilters.groupSpaceAccessValue.length + ' of ' + this.spaceFilters.groupSpaceAccess.length + ' Space Position selected. '
  result += this.spaceFilters.groupFloorNumberValue.length + ' of ' + this.spaceFilters.groupFloorNumber.length + ' Floors selected. '
  if (this.selectedManagedSpaces.length > 0) {
    result += this.selectedManagedSpaces.length + ' Managed Spaces filtered. '
  }
  return result
}

function filterByOneGroupingColumn (input, filterSet, column) {
  let result = input
  if (filterSet.length > 0) {
    result = _.filter(input, function (row) {
      return filterSet.includes(row[column])
    })
  }
  return result
}

// eslint-disable-next-line no-unused-vars
function filterByValue (input, value, column) {
  let result = _.filter(input, function (row) {
    return row[column] === value
  })
  return result
}

function getNextRequestPayload () {
  return function () {
    let startSecInDayFilter = 0
    let endSecInDayFilter = 24 * 60 * 60

    if (this.timeFilters.filterByTimeOfDay) {
      startSecInDayFilter = this.timeFilters.timeOfDayFilterStartSec
      endSecInDayFilter = this.timeFilters.timeOfDayFilterEndSec
    }

    let oneDay = 24 * 60 * 60 * 1000

    let msFilterList = []
    console.log('managed_space_filter_list', this.selectedManagedSpaces)
    if (this.selectedManagedSpaces) {
      for (let ms of this.selectedManagedSpaces) {
        msFilterList.push(ms.id.toString())
      }
      msFilterList.sort() // maintain order so that caching works well detecting request change
    }

    let request = {
      'building': this.buildingId,
      'start_time_local': (new Date(Date.parse(this.startDate))).toISOString(),
      'end_time_local': (new Date(Date.parse(this.endDate) + oneDay)).toISOString(),
      'day_of_week_filter_list': this.timeFilters.daysOfWeekFilterValue,
      'start_sec_in_day_filter': startSecInDayFilter,
      'end_sec_in_day_filter': endSecInDayFilter,
      'wait_complete_sec': 300,
      'url_expire_time_sec': 60 * 30,
      'client_download': true,
      'managed_space_filter_list': msFilterList
    }

    request.day_of_week_filter_list = this.timeFilters.daysOfWeekFilterValue

    request.commands = []
    request.commands = request.commands.concat(this.reportGroupValueSelected.serverRequestGroups)
    request.commands = request.commands.concat(this.reportAggregationValueSelected.serverRequestGroups)
    request.commands = request.commands.concat(this.reportTypeValueSelected.serverRequestGroups)
    // request.commands = request.commands.concat('force_parse_error')
    // request.commands = request.commands.concat('force_sql_error')

    return request
  }
}

function requestReportForCurrentBuilding (requestPayload) {
  // console.log('----------------- Report request payload: ' + JSON.stringify(requestPayload))
  let state = this
  state.loadingReport = true
  this.$store.dispatch('fetchBuildingReport2FromServer', requestPayload)
    .then(() => {
      console.log('Report call complete')
      collectBuildingReportFromCache.call(this, requestPayload)
      state.loadingReport = false
    })
    .catch((reason) => {
      console.warn('Report call error ...', reason)
      collectBuildingReportFromCache.call(this, requestPayload)
      state.loadingReport = false
    })
}

function collectBuildingReportFromCache (requestPayload) {
  console.log('Collect building report from cache ')
  // console.log('Collect building report from cache: ' + JSON.stringify(requestPayload))
  let pageState = this
  this.$store.dispatch('collectBuildingReport2FromCache', requestPayload).then(
    function (result) {
      console.log('collectBuildingReport2FromCache - step 1')
      // console.log(result)
      if (result) {
        pageState.nextReportIsInCache = true
        pageState.cachedReport = result
      } else {
        pageState.nextReportIsInCache = false
        pageState.cachedReport = null
      }
      console.log('collectBuildingReport2FromCache - end')
    })
}

export default {
  name: 'insightreportcontrol',
  components: {
    InsightHighchartWithTwoDimensionGrouping,
    InsightReportTimeFilters,
    InsightReportSpaceFilters,
    InsightReportRawTable,
    InsightReportManagedSpaceTable,
    InsightReportStatusPanel,
    ManagedSpaceSelectFromBuilding
  },
  data: () => {
    return {
      showDebug: false,
      showDebugButtonForStaff: true,
      reportSelectItems: reportSummarySelects.summaryReport,
      reportSelectValueSelected: reportSummarySelects.summaryReport[1].value,
      cachedReport: null,
      nextReportIsInCache: false,
      loadingReport: false,
      reportTypeDropdownItems: reportSelects.reportTypeDropdownItems,
      reportTypeValueSelected: reportSelects.reportTypeDropdownItems[0].value,
      reportGroupDropdownItems: reportSelects.reportGroupDropdownItems,
      reportGroupValueSelected: reportSelects.reportGroupDropdownItems[0].value,
      reportAggregationDropdownItems: reportSelects.reportAggregationDropdownItems,
      reportAggregationValueSelected: reportSelects.reportAggregationDropdownItems[0].value,
      reportPeriodValueSelected: 1,
      displayTimeFilters: false,
      displaySpaceFilters: false,
      displayManagedSpaceFilters: false,
      showRawReportData: false,
      timeFilters: {
        dateRange: ['2020-01-01', '2020-01-31'],
        filterByTimeOfDay: true,
        daysOfWeekFilterValue: [1, 2, 3, 4, 5],
        timeOfDayFilterStartSec: 9 * 60 * 60,
        timeOfDayFilterEndSec: 18 * 60 * 60,
        currentTimezone: 'Europe/London'
      },
      spaceFilters: {
        groupSpaceType: [],
        groupSpaceTypeValue: [],
        groupSpaceAccess: [],
        groupSpaceAccessValue: [],
        groupSpaceGroup: [],
        groupSpaceGroupValue: [],
        groupFloorNumber: [],
        groupFloorNumberValue: []
      },
      selectedManagedSpaces: [],
      customiseGraph: {
        swapGroups: false,
        lineGraph: false
      }
    }
  },
  computed: mapState({
    selectedBuildingManagedSpaces: function (state) {
      return state.building.managedSpaces
    },
    isStaff: state => state.auth.isStaff,
    selectedBuildingInfo: function (state) {
      return state.building.selectedBuildingInfo
    },
    nextRequestPayload: getNextRequestPayload(),
    buildingId: state => state.building.selectedBuildingId,
    chartGroup1 () {
      if (this.reportAggregationValueSelected.displayGroups.length > 0) {
        return this.reportAggregationValueSelected.displayGroups[0]
      } else {
        return ''
      }
    },
    chartGroup2: function () {
      if (this.reportGroupValueSelected.displayGroups.length > 0) {
        return this.reportGroupValueSelected.displayGroups[0]
      } else {
        return ''
      }
    },
    chartClusterType () {
      if (!this.cachedReport) {
        return ''
      }
      /*
      if (this.cachedReport.currentRequest.secondaryGroups.length === 0) {
        return 'single'
      }
      if (this.cachedReport.currentRequest.secondaryGroups[0] === 'hour') {
        return 'timeofday'
      }
      */
      return 'single'
    },
    chartColumnPlotted () {
      return this.reportTypeValueSelected.columnPlotted
    },
    chartPlottedPercent () {
      return this.reportTypeValueSelected.percent
    },
    chartAxisLabel () {
      return this.reportTypeValueSelected.axisLabel
    },
    chartTitlePart1 () {
      return this.reportTypeValueSelected.graphTitle
    },
    selectedBuilding: state => state.building.selectedBuilding,
    selectedBuildingReportRawDataTableValues: function () {
      console.log('Report cache entry')
      console.log(this.cachedReport)
      if (!this.cachedReport) {
        return []
      }
      if (!this.cachedReport.download) {
        return []
      }

      let result = this.cachedReport.download.data
      console.log('Raw report', result)

      // reportutil.addCalculatedOccupancyUtilisationFields(result)
      reportutil.replaceNulls(result, 'space_type')
      reportutil.replaceNulls(result, 'space_position')
      reportutil.replaceNulls(result, 'space_department')
      reportutil.replaceNulls(result, 'floor_number')
      reportutil.addManagedSpaceNames(result)
      reportutil.addDaysOfWeekNames(result)

      console.log('Enhanced report', result)
      return result
    },
    selectedBuildingReportFilteredDataTableValues: function () {
      let input = this.selectedBuildingReportRawDataTableValues
      // console.log('selectedBuildingReportFilteredDataTableValues - input: ', input)
      // let workingTimeFiltered = input
      // let dayOfWeekFiltered = filterByOneGroupingColumn(workingTimeFiltered, this.timeFilters.daysOfWeekFilterValue, 'day_of_week')
      // console.log('selectedBuildingReportFilteredDataTableValues - day of week filtered: ', input)
      let step1 = filterByOneGroupingColumn(input, this.spaceFilters.groupSpaceTypeValue, 'space_type')
      // console.log('selectedBuildingReportFilteredDataTableValues - space type filtered: ')
      let step2 = filterByOneGroupingColumn(step1, this.spaceFilters.groupSpaceAccessValue, 'space_position')
      // console.log('selectedBuildingReportFilteredDataTableValues - space position filtered: ')
      let step3 = filterByOneGroupingColumn(step2, this.spaceFilters.groupSpaceGroupValue, 'space_department')
      // console.log('selectedBuildingReportFilteredDataTableValues - all space filtered: ')
      let step4 = filterByOneGroupingColumn(step3, this.spaceFilters.groupFloorNumberValue, 'floor_number')
      // console.log('selectedBuildingReportFilteredDataTableValues - all space filtered: ')
      return step4
    },
    spaceFilterSummary: function () {
      return generateSpaceFilterSummaryText.call(this)
    },
    timeFilterSummary: function () {
      return generateTimeFilterSummaryText.call(this)
    },
    timeFilterButtonText: function () {
      return this.displayTimeFilters ? 'HIDE TIME FILTER' : 'SHOW TIME FILTER'
    },
    spaceFilterButtonText: function () {
      return this.displaySpaceFilters ? 'HIDE SPACE FILTER' : 'SHOW SPACE FILTER'
    },
    managedSpaceFilterButtonText: function () {
      let label = this.displayManagedSpaceFilters ? 'HIDE MS FILTER' : 'SHOW MS FILTER'
      if (this.selectedManagedSpaces.length > 0) {
        label += ' (' + this.selectedManagedSpaces.length + ')'
      }
      return label
    },
    reportDataButtonText: function () {
      return this.showRawReportData ? 'Hide Raw Report Data' : 'Show Raw Report Data'
    },
    groupSpaceTypeCount () {
      return this.groupSpaceType.length
    },
    groupSpaceTypeValueCount () {
      return this.groupSpaceTypeValue.length
    },
    groupSpaceAccessCount () {
      return this.groupSpaceAccess.length
    },
    groupSpaceAccessValueCount () {
      return this.groupSpaceAccessValue.length
    },
    groupSpaceGroupCount () {
      return this.groupSpaceGroup.length
    },
    groupSpaceGroupValueCount () {
      return this.groupSpaceGroupValue.length
    },
    groupFloorNumberCount () {
      return this.groupFloorNumber.length
    },
    groupFloorNumberValueCount () {
      return this.groupFloorNumberValue.length
    },
    debugTimeValues () {
      return JSON.stringify(this.timeFilters)
    },
    debugSpaceValues () {
      return JSON.stringify(this.spaceFilters)
    },
    showSpaceFilter () {
      return this.reportGroupValueSelected.showSpaceFilter && this.nextReportIsInCache
    },
    graphType () {
      return this.customiseGraph.lineGraph ? 'line' : 'column'
    },
    startDate () {
      if (this.timeFilters.dateRange.length > 1) {
        if (this.timeFilters.dateRange[0] > this.timeFilters.dateRange[1]) {
          return this.timeFilters.dateRange[1]
        }
      }
      return this.timeFilters.dateRange[0]
    },
    endDate () {
      if (this.timeFilters.dateRange.length > 1) {
        if (this.timeFilters.dateRange[0] < this.timeFilters.dateRange[1]) {
          return this.timeFilters.dateRange[1]
        }
      }
      return this.timeFilters.dateRange[0]
    },
    numberDays: function () {
      let start = new Date(this.startDate)
      let end = new Date(this.endDate)
      return 1 + (Math.abs(end - start) / (1000 * 60 * 60 * 24))
    },
    dateRangeTooLong: function () {
      if (!this.numberDays) {
        return false
      }
      if (!this.reportAggregationValueSelected.maxDays) {
        return false
      }
      return this.numberDays > this.reportAggregationValueSelected.maxDays
    },
    showExtendedPeriodWarning: function () {
      if (!this.reportAggregationValueSelected.showExtendedPeriodWarning) {
        return false
      }
      return this.reportAggregationValueSelected.showExtendedPeriodWarning
    },
    reportPeriodDropdownItems: function () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return [
        {
          text: 'This Month (' + date.getMonth() + '/' + date.getFullYear() + ')',
          value: 1,
          newdate: [
            moment(firstDay).format('YYYY-MM-DD'),
            moment(lastDay).format('YYYY-MM-DD')],
          displayTimeFilters: false
        },
        {
          text: 'Q3 2021',
          value: 2,
          newdate: ['2021-07-01', '2021-09-30'],
          displayTimeFilters: false
        },
        {
          text: 'Q2 2021',
          value: 3,
          newdate: ['2021-04-01', '2021-06-30'],
          displayTimeFilters: false
        },
        {
          text: 'Q1 2021',
          value: 4,
          newdate: ['2021-01-01', '2021-03-31'],
          displayTimeFilters: false
        },
        {
          text: 'This Year (2021)',
          value: 5,
          newdate: ['2021-01-01', '2021-06-30'],
          displayTimeFilters: false
        },
        {
          text: 'Last Year (2020)',
          value: 6,
          newdate: ['2020-01-01', '2020-12-31'],
          displayTimeFilters: false
        },
        {
          text: 'Previous Year (2019)',
          value: 7,
          newdate: ['2019-01-01', '2019-12-31'],
          displayTimeFilters: false
        },
        // {
        //   text: 'All Data',
        //   value: 6,
        //   newdate: ['2017-01-01', '2021-12-31'],
        //   displayTimeFilters: false
        // },
        {
          text: 'Custom ' + this.startDate + ' to ' + this.endDate + '',
          value: 0,
          newdate: null,
          displayTimeFilters: true
        }
      ]
    },
    resultUrl: function () {
      if (!this.nextReportIsInCache) {
        return undefined
      }
      if (!this.cachedReport) {
        return undefined
      }
      if (!this.cachedReport.report) {
        return undefined
      }
      return this.cachedReport.report.url
    },
    reportErrorMessage: function () {
      if (!this.nextReportIsInCache) {
        return null
      }
      if (!this.cachedReport) {
        return null
      }
      return this.cachedReport.error
    }
  }),
  watch: {
    // Building change
    buildingId: function () {
      this.displayTimeFilters = false
      this.displaySpaceFilters = false
      this.displayManagedSpaceFilters = false
      this.selectedManagedSpaces = []
    },
    // Watch for new data arrive
    selectedBuildingReportRawDataTableValues: function (val) {
      updateSpaces.call(this, val)
    },
    nextRequestPayload: {
      deep: true,
      handler: function () {
        console.log('next request payload change - check data in cache')
        console.log('Report request payload: ' + JSON.stringify(this.nextRequestPayload))
        collectBuildingReportFromCache.call(this, this.nextRequestPayload)
      }
    }
  },
  methods: {
    clickLoadReportData: function () {
      console.log('Load report data pushed')
      this.displayTimeFilters = false
      this.displaySpaceFilters = false
      this.displayManagedSpaceFilters = false
      requestReportForCurrentBuilding.call(this, this.nextRequestPayload)
    },
    clickDisplayTimeFilters: function () {
      this.displayTimeFilters = !this.displayTimeFilters
      if (this.displayTimeFilters) {
        this.reportPeriodValueSelected = 0
      }
    },
    clickDisplayManagedSpaceFilters: function () {
      this.displayManagedSpaceFilters = !this.displayManagedSpaceFilters
    },
    periodSelectControlChange: function () {
      console.log('Period control change', this.reportPeriodValueSelected)
      if (this.reportPeriodValueSelected === null) {
        return
      }
      let matched = this.reportPeriodDropdownItems.filter(row => row.value === this.reportPeriodValueSelected)[0]
      console.log('Matched new date record', matched)
      if (!matched) {
        return
      }
      if (matched.newdate) {
        this.timeFilters.dateRange = matched.newdate
      }
      if (matched.displayTimeFilters !== null) {
        this.displayTimeFilters = matched.displayTimeFilters
      }
    }
  },
  mounted: function () {
    // Force period to match control after loading
    this.periodSelectControlChange()
  }
}

</script>

<style scoped>

>>> .v-input__slot::before {
  border-style: none !important;
}

.layer-btn {
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 10px;
  letter-spacing: 3px;
}

.layer-btn-large {
  font-family: 'NeutrifPro-Bold', serif;
  font-size: 14px;
  letter-spacing: 3px;
}

</style>
